<div class="message-wrapper" [ngClass]="isSelf ? 'message-wrapper_self' : 'message-wrapper_other'">
  <message-tail class="tail" [ngClass]="isSelf ? 'tail_self' : 'tail_other'"></message-tail>

  <div
    class="message"
    [ngClass]="isSelf ? 'message_self' : 'message_other'"
    [ngStyle]="{ 'max-width': maxWidth + 'px' }"
  >
    <div *ngIf="!isSelf" class="message__author text_size-s" [ngStyle]="{ color: message.userName | generateColor }">
      {{ message.userName }}
    </div>

    <message-reply
      *ngIf="replyMessage"
      class="message__reply"
      [message]="replyMessage"
      [color]="isSelf ? 'white' : (replyMessage.userName | generateColor)"
      [linkColor]="isSelf ? 'white' : 'blue'"
    ></message-reply>

    <div class="message__content">
      <ng-content></ng-content>
    </div>

    <div *ngIf="!!permissions?.canSendReactions && message.reactions?.length" class="message__reactions-list">
      <app-reaction-list
        [reactions]="message.reactions"
        (reactionClicked)="sendReaction($event, message)"
      ></app-reaction-list>
    </div>

    <div class="message__meta">
      <div class="message__date text_size-xs">
        {{ message.dateCreated | date: 'HH:mm' }}
      </div>

      <!-- <app-icon
        class="message__status"
        [ngClass]="message.readAnyOne ? 'message__status_read' : 'message__status_send'"
        [src]="message.deliveredToAnyOne ? (message.readAnyOne ? 'check-check' : 'check') : 'clock'"
        size="14px"
      ></app-icon> -->
    </div>
  </div>
</div>
